import Env from '../base/env';
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
import { SplitText } from '../vendor/gsap-bonus-umd/SplitText';
gsap.registerPlugin(ScrollTrigger,SplitText);
import easesCustom from '../fx/CustomEases';

export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    //!
    this.VARS = {}
    this.VARS.NEW_SLIDE = 0
    this.VARS.CURRENT_SLIDE = -1
    this.VARS.SLIDE_ACTIVE = false
    this.VARS.TOTAL_SLIDES = this.ref.slide.length - 1
    this.VARS.IS_ANIMATING = false
    this.VARS.Z_INDEX = 100
    //!
    this.FX = {}
    this.FX.title = []
    this.FX.desc = []
    this.FX.targets = []
    //! Fns
    gsap.delayedCall(Env.timingDelayFx/1000,()=>{
      this.makeTargets()
      this.makeSticky()
    })
    this.prepareFx()
  }

  makeSticky()
  {
    this.sticky = ScrollTrigger.create({
      trigger:this.DOM.view,
      start:'top top',
      end:'bottom top',
      markers:false,
      scrub:true,
      pin:this.ref.slideshow[0],
      pinSpacing:true,
      invalidateOnRefresh: true,
    })
  }

  makeTargets()
  {
    for(let [i,target] of this.ref.target.entries())
    {
      const instance = ScrollTrigger.create({
        trigger:target,
        start:'top bottom',
        end:'bottom center',
        onEnter:()=>{
          this.triggerScroll(i)
        },
        onEnterBack:()=>{
          this.triggerScroll(i)
        }
      })
      this.FX.targets.push(instance)

      // const instanceMiddle = ScrollTrigger.create({
      //   trigger:target,
      //   start:'top center',
      //   // end:'bottom top',
      //   markers:true,
      //   onEnter:()=>{
      //     // console.log('baller',i);
      //     console.log(this.VARS.CURRENT_SLIDE,i);
      //     // this.triggerScroll(i)
      //   },
      //   onEnterBack:()=>{
      //     // this.triggerScroll(i)
      //   }
      // })
      // this.FX.targets.push(instance)
    }
  }

  move()
  {
    const DOM = {}
    DOM.currentSlide = this.ref.slide[this.VARS.CURRENT_SLIDE]
    if(DOM.currentSlide != null) {
      DOM.currentTitle = DOM.currentSlide.querySelector('.fxTitle')
      DOM.currentDesc = DOM.currentSlide.querySelector('.fxDesc')
    }

    DOM.activeSlide = this.ref.slide[this.VARS.NEW_SLIDE]
    DOM.activeThumb = DOM.activeSlide.querySelector('.fxThumbContainer')
    DOM.activeBG = DOM.activeSlide.querySelector('.fxVisualContainer')
    DOM.activeTitle = DOM.activeSlide.querySelector('.fxTitle')
    DOM.activeDesc = DOM.activeSlide.querySelector('.fxDesc')
    const coords = DOM.activeSlide.getBoundingClientRect()
    const coordsThumb = DOM.activeThumb.getBoundingClientRect()
    const tl = gsap.timeline()


    for(let [i,slide] of this.ref.slide.entries()) {
      if(i == this.VARS.NEW_SLIDE) {
        slide.classList.add('is-active')
      } else {
        slide.classList.remove('is-active')
      }
    }

    this.VARS.Z_INDEX++
    this.VARS.IS_ANIMATING = true
    tl
    .add(()=>{
      for(let fx of this.FX.title) {
        gsap.to(fx.words, { autoAlpha:0, duration:.3 })
      }
      for(let fx of this.FX.desc) {
        gsap.to(fx.lines, { autoAlpha:0, duration:.3  })
      }
    })
    .add([
      //! Visual
      gsap.fromTo(
        DOM.activeBG,
        {
          clip:`rect(0px,${coords.width}px,0px,0px)`

        },
        {
          clip:`rect(0px,${coords.width}px,${coords.height}px,0px)`,
          duration:.8,
          ease:easesCustom.quart,
          onStart:()=>{
            gsap.set(DOM.activeSlide,{ zIndex:this.VARS.Z_INDEX })
          }
        }
      ),
      gsap.fromTo(
        DOM.activeSlide.querySelector('.fxVisual'),
        {
          scale:1.2

        },
        {
          scale:1,
          duration:.8,
          ease:'cubic.out',
          delay:.4
        }
      ),

      //! Texts
      gsap.fromTo(
        this.FX.title[this.VARS.NEW_SLIDE].words,
        {
          autoAlpha:0,
          y:40
        },
        {
          autoAlpha:1,
          y:0,
          duration:1.2,
          ease:'quint.inOut',
          stagger:.05,
          delay:.1
        }
      ),
      gsap.fromTo(
        this.FX.desc[this.VARS.NEW_SLIDE].lines,
        {
          autoAlpha:0,
          y:40,
        },
        {
          autoAlpha:1,
          y:0,
          duration:1.2,
          ease:'quint.inOut',
          stagger:.1,
          delay:.2
        }
      )
    ],'+=.4')
    .add([
      //! Thumb
      gsap.fromTo(
        DOM.activeThumb,
        {
          clip:`rect(${coordsThumb.height}px,${coordsThumb.width}px,${coordsThumb.height}px,0px)`

        },
        {
          clip:`rect(0px,${coordsThumb.width}px,${coordsThumb.height}px,0px)`,
          duration:.8,
          ease:easesCustom.quart
        }
      ),
      gsap.fromTo(
        DOM.activeSlide.querySelector('.fxThumb'),
        {
          scale:1.2

        },
        {
          scale:1,
          duration:.8,
          ease:'cubic.out',
          delay:.4
        }
      ),
    ],`-=${ (Env.mobileCSS)?1.5:1.4 }`)
    .add(()=>{
      for(let [i,slide] of this.ref.slide.entries()) {
        gsap.set(slide.querySelector('.fxThumb'), { clearProps:'all' })
        gsap.set(slide.querySelector('.fxVisual'), { clearProps:'all' })
        if(i == this.VARS.NEW_SLIDE) {
          gsap.set(slide.querySelector('.fxVisualContainer'), { clearProps:'all' })
          gsap.set(slide.querySelector('.fxThumbContainer'), { clearProps:'all' })
        } else {
          gsap.set(slide.querySelector('.fxVisualContainer'), { clip:`rect(0px,${coords.width}px,0px,0px)` })
          gsap.set(slide.querySelector('.fxThumbContainer'), { clip:`rect(${coordsThumb.height}px,${coordsThumb.width}px,${coordsThumb.height}px,0px)` })
          gsap.set(this.FX.title[i].words, { autoAlpha:0 })
          gsap.set(this.FX.desc[i].lines, { autoAlpha:0 })
        }
      }
      this.VARS.IS_ANIMATING = false
      this.VARS.CURRENT_SLIDE = this.VARS.NEW_SLIDE
    })
    tl.timeScale(2)

  }


  prepareFx()
  {
    for(let slide of this.ref.slide) {
      const parentTitle = new SplitText(slide.querySelector('.fxTitle'), { type:'lines', linesClass:'tw-overflow-hidden' })
      this.FX.title.push(new SplitText(slide.querySelector('.fxTitle'), { type:'words' }))

      this.FX.desc.push(new SplitText(slide.querySelector('.fxDesc'), { type:'lines' }))
      const parentDesc = new SplitText(slide.querySelector('.fxDesc'), { type:'lines', linesClass:'tw-overflow-hidden'  })
    }
    for(let fx of this.FX.title) {
      gsap.set(fx.words, { autoAlpha:0 })
    }
    for(let fx of this.FX.desc) {
      gsap.set(fx.lines, { autoAlpha:0 })
    }
  }

  triggerScroll(index)
  {
    if(this.VARS.IS_ANIMATING == false && index != this.VARS.CURRENT_SLIDE) {
      this.VARS.NEW_SLIDE = index
      this.move()
    }

  }

  unmount()
  {
    this.sticky.kill(true)
    for(let target of this.FX.targets) {
      target.kill(true)
    }
  }
}
